var Formatter = require('formatter');
var HashDialogView = require('hashdialogview');
var PayViewMixins = require('payviewmixins');
var UpgradeSchedules = require('./upgrade-schedules.es6').default;


var UpgradeView = HashDialogView.extend($.extend({}, PayViewMixins, {
    el: '#upgradeOverlayContent',
    wrapper: $('#upgradeContainer'),
    initialize: function (options) {
        HashDialogView.prototype.initialize.call(this, options);
        PayViewMixins.initialize.call(this, options);

        this.inactiveFor = $('.inactiveFor');
        this.zombieLimit = $('.zombieLimit');
        this.zombifiedAgo = $('.zombifiedAgo');

        this.upgradeSchedules = new UpgradeSchedules(options, this);

        this.upgradeCurrentOrg = this.$('.upgradeCurrentOrg');
        this.annualSwitch = this.$('.annualSwitch');

        this.billingDetails = $('#soloBillingDetails');

        this.renderSessionState();
        this.renderPay();
        this.model.bind('featureChange:upgrades', this.renderSessionState, this);
        this.model.bind('orgsChange', this.renderSessionState, this);
        this.model.bind('change:limits_name', this.renderSessionState, this);
        this.model.bind('setZombie', this.renderZombieLimit, this);
        this.model.bind('plansChange', this.renderPlans, this);
        this.model.bind('billingUpdate', this.renderBilling, this);
        this.model.bind('stat', this.stat, this);

        this.formatter = new Formatter;

        _.bindAll(this, 'show');

        this.router.route('?/upgrade', 'show', this.show);
        this.router.route('?/upgrade=:plan', 'show', this.show);

        this.bind('open', this.onOpen, this);
    },
    events: _.extend({}, HashDialogView.prototype.events, PayViewMixins.events),

    afterPay: function (response) {
        PayViewMixins.afterPay.call(this, response);
        this.upgradeSchedules.afterPay(response);
        this.renderBillingDetails();
    },
    subscribeMonthly: function (afterStripe) {
        this.stripeCheckout(
            'Upgrade',
            _.bind(function (data, mixinCallback) {
                if (afterStripe) {
                    afterStripe(data);
                }
                if (data) {
                    this.model.subscribe(data, _.bind(function (response) {
                        mixinCallback(response);
                    }, this));
                }
            }, this), {
                description: 'Monthly upgrade for ' + this.model.get('name'),
                amount: this.getAmount(),
                subscription: true
            }
        );
    },
    subscribeYearly: function (renew, afterStripe, callback) {
        var description = renew ? 'Yearly upgrade' : 'One time upgrade';
        description += ' for ' + this.model.get('name');
        var plan = 'yearly';
        this.stripeCheckout(
            'Upgrade',
            _.bind(function (data, mixinCallback) {
                if (afterStripe) {
                    afterStripe(data);
                }
                if (data) {
                    if (renew) {
                        data.plan = plan;
                        this.model.subscribe(data, mixinCallback);
                    } else {
                        this.model.subscribeOneOff(data, mixinCallback);
                    }
                }
            }, this), {
                description: description,
                amount: this.getYearlyAmount(),
                plan: plan,
                subscription: !!renew
            }
        );
    },

    payDone: function () {
        this.$('.payInvoice').hide();
        this.$('.payComplete').show();
    },
    fetchBillingInfo: function () {
        this.$el.addClass('isLoadingBilling');
        this.model.getBillingInfo(_.bind(function (billingResponse, failInfo) {
            this.$el.removeClass('isLoadingBilling');
            if (billingResponse.success) {
                this.removeBillingInfoError();
                this.renderBillingDetails();
                this.focusFirst();
            }
        }, this));
    },

    // PayViewMixins
    billingCancelSureText: 'Are you sure you want to cancel this subscription?',
    renderPayActiveSub: function () {
        if (this.model.hasActiveOneOffSubscription() && !this.model.hasActiveRecurringSubscription()) {
            this.$('.payOneOffExtend').show();
        }
    },
    getNewPayButtons: function () {
        var tpl;
        if (this.model.hasActiveSubscription()) {
            if (this.model.hasActiveOneOffSubscription()) {
                tpl = 'billing-pay-extend';
            }
        } else {
            tpl = 'billing-pay-new';
        }
        if (tpl) {
            var payButtons = $($('#tpl-' + tpl).html());
            return $('<div>').append(payButtons).html();
        }
    },
    formatPlan: function (b) {
        return 'Recurring — ' + this.formatter.amount(b.currency, b.amount) + '/' + b.interval;
    },
    formatOneOffPlan: function (oo, charge) {
        var format = 'One off — ';
        if (charge) {
            format += this.formatter.amount(charge.currency, charge.amount) + ' ';
        }
        format += 'for ' + oo.interval_count + ' ' + oo.interval;
        return format;
    },
    formatSubscriptionInvoiceItem: function (sub) {
        var description = 'Subscription payment';
        if (sub.period) {
            description += ' for ' + this.formatter.date(sub.period.start) + ' — ' + this.formatter.date(sub.period.end);
        } else if (sub.created) {
            description += ' for ' + this.formatter.date(sub.created);
        }
        return description;
    },
    formatOneOffSubscriptionInvoiceItem: function (sub) {
        return 'One off subscription for ' + this.formatter.date(sub.start_date) + ' — ' + this.formatter.date(sub.end_date);
    },
    stripeCheckout: function (label, callback, options) {
        PayViewMixins.stripeCheckout.call(this, label, callback, $.extend(true, {}, {
            email: this.model.get('email'),
            currency: this.model.getCurrency()
        }, options));
    },
    clickPayButton: function (e) {
        e.preventDefault();
        this.upgradeRestore();
    },
    upgradeRestore: function () {
        this.billingDetails.hide();
        this.upgradeSchedules.show();
        this.focusFirst();
    },
    cancelUpgrade: function () {
        this.billingDetails.show();
        this.upgradeSchedules.hide();
    },

    renderPlans: function () {
        if (this.model.plans.solo) {
            $('.soloPayPrice').text(this.formatter.amount(
                this.model.plans.currency,
                this.model.plans.solo.amount,
                1,
                0
            ));
        }
    },
    getAmount: function () {
        return this.model.plans.solo.amount;
    },
    getYearlyAmount: function (currency) {
        currency = currency || this.model.getCurrency();
        return this.model.plans.solo_yearly[currency].amount;
    },
    stat: function () {
        if (this.isVisible()) {
            this.model.getBillingInfo();
        }
    },
    renderBillingDetails: function () {
        var contents = this.formatBillingDetails();
        this.billingDetails.html(contents);
        var hasSubscribed = this.model.hasSubscribed();
        this.upgradeSchedules.setUpgradedState(hasSubscribed);
        if (!this.isStripeCheckoutShown() && (
            hasSubscribed || !this.upgradeSchedules.isVisible()
        )) {
            this.billingDetails.toggle(hasSubscribed);
            this.upgradeSchedules.toggle(!hasSubscribed);
        }
        this.renderPlans();
        if (!this.model.hasActiveSubscription()) {
            this.$('.payComplete').hide();
        }
    },
    show: function (upgrade) {
        this.fetchBillingInfo();
        HashDialogView.prototype.show.call(this);
    },
    renderBilling: function () {
        this.renderSessionState();
        this.renderPay();
    },
    renderSessionState: function () {
        this.upgradeCurrentOrg.toggle(this.model.hasActiveOrgs());
        this.annualSwitch.toggle(this.model.hasActiveMonthlySubscription());
        this.upgradeCurrentOrg.toggleClass('subscribed', this.model.hasActiveSubscription());
    },
    renderZombieLimit: function () {
        if (this.model.isZombied()) {
            this.zombieLimit.text(this.model.getLimit('zombiehours') + ' hours');
            var zombieDate = new Date(this.model.getZombieDate());
            this.zombifiedAgo.attr('title', zombieDate.toISOString()).text(zombieDate.formatFullDate()).timeago();
            if (this.model.softZombie && this.model.isZombieLimited()) {
                var inactiveStartDate = new Date(zombieDate);
                inactiveStartDate.addHours(-this.model.getLimit('zombiehours'));
                var strings = $.extend(true, {}, $.timeago.settings.strings);
                strings.prefixAgo = null;
                strings.suffixAgo = null;
                this.inactiveFor.attr('title', inactiveStartDate.toISOString()).text(inactiveStartDate.formatFullDate()).timeago('init', strings);
            }
        }
    }
}));

module.exports = UpgradeView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/upgradeview.js
// module id = wDHD
// module chunks = 1